var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "newUgcModal",
    class: ['new-ugc-modal-wrapper', 'new-ugc-modal-wrapper-step-' + _vm.activeViewComponent + '-wrapper'],
    style: _vm.modalStyles,
    attrs: {
      "modal-name": "newUgcModal",
      "modal-classes": "new-ugc-modal",
      "headerTitle": _vm.$store.state.translations.data[_vm.titles[_vm.activeViewComponent]],
      "headerImg": !!_vm.showHeaderImage[_vm.activeViewComponent],
      "click-to-close": false,
      "isUGCModal": true,
      "showStepsView": !!_vm.showStepsView[_vm.activeViewComponent],
      "cta-primary-button": _vm.ctaButtons[_vm.activeViewComponent],
      "cta-primary-button-arguments": _vm.ctaButtonArguments[_vm.activeViewComponent],
      "disable-buttons": _vm.$store.state.ugc.stateManager.isLoading,
      "disable-next-back-buttons": _vm.$store.state.ugc.stateManager.activeControl !== '',
      "disable-close-button": _vm.$store.state.utils.errorModalProcess
    },
    on: {
      "cta-action": _vm.ctaAction,
      "go-back": _vm.goBack,
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose,
      "close-action": _vm.close
    }
  }, [_c('ugc-topbar', {
    ref: "ugcTopBar",
    attrs: {
      "hide": true
    },
    on: {
      "disable-next-back-buttons": _vm.updateDisableNextBackButtons
    }
  }), _c('ugc-go-back-button', {
    ref: "ugcBackButton",
    staticClass: "hide"
  }), _c(_vm.activeViewComponent, _vm._b({
    ref: "content",
    tag: "component",
    on: {
      "showBackButton": _vm.showBackButton,
      "showIconButton": _vm.showIconButton,
      "showCtaButton": _vm.showCtaButton
    }
  }, 'component', _vm.componentAttributes[_vm.activeViewComponent], false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }